module.exports = __webpack_public_path__ + "alumni-6064d797.webp";